/**
 * Check if a color value is valid for CSS use.
 */
export function isValidColor(color) {
    if (!color || typeof color !== 'string') {
        return false;
    }
    const hexPattern = /^#([0-9A-Fa-f]{3}|[0-9A-Fa-f]{6}|[0-9A-Fa-f]{8})$/;
    const rgbPattern = /^rgba?\(.*\)$/;
    const hslPattern = /^hsla?\(.*\)$/;
    return (hexPattern.test(color) ||
        rgbPattern.test(color) ||
        hslPattern.test(color) ||
        color.match(/^[a-z]+$/i) !== null);
}
/**
 * Lighten a hex color by a percentage (0–100).
 */
function lightenColor(color, percent) {
    let hex = color.replace('#', '');
    if (hex.length === 3) {
        hex = hex
            .split('')
            .map((c) => c + c)
            .join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const lighten = (component) => {
        const amount = Math.round((255 - component) * (percent / 100));
        return Math.min(255, component + amount);
    };
    const toHex = (n) => {
        const value = n.toString(16);
        return value.length === 1 ? '0' + value : value;
    };
    return `#${toHex(lighten(r))}${toHex(lighten(g))}${toHex(lighten(b))}`;
}
/**
 * Build a button background from a base color (subtle gradient for hex colors).
 */
export function buildButtonBackground(color) {
    if (color.startsWith('#')) {
        const lighterColor = lightenColor(color, 10);
        return `linear-gradient(135deg, ${color}, ${lighterColor})`;
    }
    return color;
}
//# sourceMappingURL=button.js.map